<div class="page-container" *ngIf="!loading && customer">
  <div class="detail-hero">
    <div class="hero-main">
      <button mat-icon-button routerLink="/wartung/kunden" matTooltip="Zurück zur Kundenliste" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="customer-identity">
        <div class="logo-stack">
          <div class="customer-avatar-lg" *ngIf="!customer.logoPath">{{getCustomerInitial(customer)}}</div>
          <div class="customer-logo-lg" *ngIf="customer.logoPath">
            <img [src]="getLogoUrl(customer.logoPath)" alt="Logo">
          </div>
          <div class="logo-upload-area">
            <button mat-icon-button matTooltip="Logo hochladen" (click)="logoInput.click()" class="logo-upload-btn">
              <mat-icon>photo_camera</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Logo entfernen" (click)="removeLogo()" *ngIf="customer.logoPath" class="logo-remove-btn">
              <mat-icon>close</mat-icon>
            </button>
            <input #logoInput type="file" hidden accept="image/png,image/jpeg,image/gif,image/svg+xml,image/webp" (change)="onLogoSelected($event)">
          </div>
        </div>

        <div class="identity-copy">
          <span class="eyebrow">Kundendetail</span>
          <h1>{{customer.name}}</h1>
          <div class="identity-meta">
            <span *ngIf="customer.address">
              <mat-icon class="meta-icon">location_on</mat-icon>
              {{customer.address}}
            </span>
            <span>
              <mat-icon class="meta-icon">electrical_services</mat-icon>
              {{equipments.length}} Anlage{{equipments.length === 1 ? '' : 'n'}}
            </span>
            <span>
              <mat-icon class="meta-icon">assignment</mat-icon>
              {{getOpenMaintenanceCount()}} offen
            </span>
          </div>
        </div>
      </div>

      <div class="hero-actions">
        <a mat-stroked-button *ngIf="customer.address" [href]="getMapLink(customer.address)" target="_blank" rel="noopener">
          <mat-icon>map</mat-icon>
          Route
        </a>
        <button mat-raised-button color="primary" (click)="editCustomer()">
          <mat-icon>edit</mat-icon>
          Bearbeiten
        </button>
      </div>
    </div>

    <aside class="contact-panel" [class.empty-contact]="!hasContactDetails(customer)">
      <div class="panel-heading">
        <div>
          <span class="eyebrow">Ansprechperson</span>
          <h2>{{customer.contactPersonName || 'Kein Kontakt hinterlegt'}}</h2>
        </div>
        <button mat-icon-button (click)="editCustomer()" matTooltip="Kontaktdaten bearbeiten">
          <mat-icon>edit</mat-icon>
        </button>
      </div>

      <div class="contact-grid" *ngIf="hasContactDetails(customer); else noContact">
        <a class="contact-tile" *ngIf="customer.contactPersonPhone" [href]="getTelLink(customer.contactPersonPhone)">
          <mat-icon>phone</mat-icon>
          <span>
            <small>Telefon</small>
            <strong>{{customer.contactPersonPhone}}</strong>
          </span>
        </a>

        <a class="contact-tile" *ngIf="customer.contactPersonEmail" [href]="getMailtoLink(customer.contactPersonEmail)">
          <mat-icon>email</mat-icon>
          <span>
            <small>E-Mail</small>
            <strong>{{customer.contactPersonEmail}}</strong>
          </span>
        </a>

        <div class="contact-tile muted" *ngIf="customer.contactPersonName">
          <mat-icon>badge</mat-icon>
          <span>
            <small>Name</small>
            <strong>{{customer.contactPersonName}}</strong>
          </span>
        </div>
      </div>

      <ng-template #noContact>
        <div class="empty-contact-message">
          <mat-icon>contact_mail</mat-icon>
          <span>Telefon oder E-Mail ergänzen, damit der Kunde direkt erreichbar ist.</span>
        </div>
      </ng-template>
    </aside>
  </div>

  <!-- Summary Stats -->
  <div class="summary-strip">
    <button type="button" class="summary-item" (click)="selectTab(0)">
      <mat-icon>electrical_services</mat-icon>
      <span class="summary-value">{{equipments.length}}</span>
      <span class="summary-label">Anlagen</span>
    </button>
    <button type="button" class="summary-item" (click)="selectTab(1)">
      <mat-icon>event_repeat</mat-icon>
      <span class="summary-value">{{plannedMaintenances.length}}</span>
      <span class="summary-label">Geplante Wartungen</span>
    </button>
    <button type="button" class="summary-item" (click)="selectTab(2)">
      <mat-icon>build</mat-icon>
      <span class="summary-value">{{serviceCallMaintenances.length}}</span>
      <span class="summary-label">Einsätze</span>
    </button>
    <button type="button" class="summary-item" (click)="selectTab(1)" [class.alert]="getOverdueMaintenanceCount() > 0">
      <mat-icon>{{getOverdueMaintenanceCount() > 0 ? 'warning' : 'task_alt'}}</mat-icon>
      <span class="summary-value">{{getOverdueMaintenanceCount() || getCompletionPercent() + '%'}}</span>
      <span class="summary-label">{{getOverdueMaintenanceCount() > 0 ? 'Überfällig' : 'Erledigt'}}</span>
    </button>
  </div>

  <!-- Tabs -->
  <mat-tab-group
    [selectedIndex]="activeTab"
    (selectedIndexChange)="onTabChanged($event)"
    (touchstart)="onTabTouchStart($event)"
    (touchend)="onTabTouchEnd($event)"
    (touchcancel)="onTabTouchCancel()"
    animationDuration="200ms"
    class="main-tabs">

    <!-- Tab 1: Anlagen / Verteiler -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">electrical_services</mat-icon>
        Anlagen & Verteiler
        <span class="tab-count" *ngIf="equipments.length">{{equipments.length}}</span>
      </ng-template>

      <div class="tab-content">
        <div class="tab-actions" *ngIf="canEdit && equipments.length > 0">
          <button mat-raised-button color="primary" (click)="addEquipment()">
            <mat-icon>add</mat-icon> Neuer Verteiler
          </button>
        </div>

        <div *ngIf="equipments.length === 0" class="empty-tab">
          <mat-icon>electrical_services</mat-icon>
          <p>Noch keine Anlagen/Verteiler angelegt.</p>
          <button mat-raised-button color="primary" *ngIf="canEdit" (click)="addEquipment()">
            <mat-icon>add</mat-icon> Ersten Verteiler anlegen
          </button>
        </div>

        <div class="equipment-grid" *ngIf="equipments.length > 0">
          <div class="equipment-card" *ngFor="let eq of equipments; trackBy: trackByEquipmentId">
            <div class="eq-header">
              <div class="eq-icon">
                <mat-icon>electrical_services</mat-icon>
              </div>
              <div class="eq-info">
                <h3>{{eq.name}}</h3>
                <span class="eq-location" *ngIf="eq.location">
                  <mat-icon class="meta-icon">place</mat-icon> {{eq.location}}
                </span>
              </div>
              <div class="eq-actions">
                <button mat-icon-button (click)="editEquipment(eq, $event)" matTooltip="Bearbeiten">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteEquipment(eq, $event)" matTooltip="Löschen">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="eq-stats">
              <span><strong>{{getMaintenanceCountForEquipment(eq)}}</strong> Wartungen</span>
              <span *ngIf="getLastMaintenanceDate(eq)">Letzte: {{getLastMaintenanceDate(eq) | date:'dd.MM.yyyy'}}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 2: Geplante Wartungen -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">event_repeat</mat-icon>
        Planmäßige Wartungen
        <span class="tab-count" *ngIf="plannedMaintenances.length">{{plannedMaintenances.length}}</span>
      </ng-template>

      <div class="tab-content">
        <div class="tab-actions" *ngIf="canEdit && plannedMaintenances.length > 0">
          <button mat-raised-button color="primary" (click)="addPlannedMaintenance()">
            <mat-icon>add</mat-icon> Wartung planen
          </button>
        </div>

        <div *ngIf="plannedMaintenances.length === 0" class="empty-tab">
          <mat-icon>event_repeat</mat-icon>
          <p>Noch keine planmäßigen Wartungen.</p>
          <button mat-raised-button color="primary" *ngIf="canEdit" (click)="addPlannedMaintenance()">
            <mat-icon>add</mat-icon> Wartung planen
          </button>
        </div>

        <div class="maintenance-list" *ngIf="plannedMaintenances.length > 0">
          <div class="m-card" *ngFor="let m of plannedMaintenances; trackBy: trackByMaintenanceId">
            <div class="m-date-col" (click)="openMaintenance(m)">
              <div class="m-date-badge" [class.overdue]="m.status === 'Overdue'">
                <span class="day">{{m.scheduledDate | date:'dd'}}</span>
                <span class="month">{{m.scheduledDate | date:'MMM yy'}}</span>
              </div>
            </div>
            <div class="m-info-col" (click)="openMaintenance(m)">
              <h4>{{m.title}}</h4>
              <div class="m-meta-row">
                <span class="m-equipment"><mat-icon class="meta-icon">electrical_services</mat-icon> {{m.equipment?.name ?? '–'}}</span>
                <span class="m-recurrence"><mat-icon class="meta-icon">repeat</mat-icon> {{getRecurrenceLabel(m.recurrenceType)}}</span>
                <span *ngIf="m.assignedUsers?.length" class="m-tech"><mat-icon class="meta-icon">group</mat-icon> {{getTechnicianNames(m)}}</span>
                <span *ngIf="!m.assignedUsers?.length && (m.assignedUser || m.assignedEmployee)" class="m-tech"><mat-icon class="meta-icon">person</mat-icon> {{m.assignedUser?.userName ?? m.assignedEmployee?.fullName}}</span>
              </div>
              <mat-progress-bar *ngIf="m.status === 'InProgress'" mode="determinate" [value]="m.progressPercent" class="m-progress"></mat-progress-bar>
            </div>
            <div class="m-status-col">
              <span class="status-chip" [ngClass]="getStatusClass(m.status)">{{getStatusLabel(m.status)}}</span>
              <button class="delete-btn" (click)="deleteMaintenance(m, $event)" title="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 3: Einsätze / Reparaturen -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        Einsätze & Reparaturen
        <span class="tab-count" *ngIf="serviceCallMaintenances.length">{{serviceCallMaintenances.length}}</span>
      </ng-template>

      <div class="tab-content">
        <div class="tab-actions service-toolbar" *ngIf="serviceCallMaintenances.length > 0">
          <button mat-raised-button color="accent" *ngIf="canEdit" (click)="addServiceCall()">
            <mat-icon>add</mat-icon> Neuer Einsatz
          </button>
          <mat-form-field appearance="outline" class="person-filter-field" subscriptSizing="dynamic">
            <mat-label>Nach Person filtern</mat-label>
            <mat-icon matPrefix>person_search</mat-icon>
            <mat-select [(ngModel)]="serviceCallPersonFilter" (selectionChange)="onServiceCallPersonFilterChange()">
              <mat-option value="all">Alle Personen ({{serviceCallMaintenances.length}})</mat-option>
              <mat-option *ngFor="let option of serviceCallPersonOptions" [value]="option.key">
                {{option.label}} ({{option.count}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="serviceCallMaintenances.length === 0" class="empty-tab">
          <mat-icon>build</mat-icon>
          <p>Noch keine Einsätze oder Reparaturen dokumentiert.</p>
          <button mat-raised-button color="accent" *ngIf="canEdit" (click)="addServiceCall()">
            <mat-icon>add</mat-icon> Ersten Einsatz erfassen
          </button>
        </div>

        <div *ngIf="serviceCallMaintenances.length > 0 && filteredServiceCallMaintenances.length === 0" class="empty-tab">
          <mat-icon>person_search</mat-icon>
          <p>Keine Einsätze für die ausgewählte Person.</p>
          <button mat-stroked-button (click)="resetServiceCallPersonFilter()">
            <mat-icon>filter_alt_off</mat-icon> Filter zurücksetzen
          </button>
        </div>

        <!--
          data-service-call-id dient dem Wiederfinden der Scrollposition beim
          Zurückkommen aus einem Einsatz (siehe restoreScrollPosition).
        -->
        <div class="maintenance-list" *ngIf="filteredServiceCallMaintenances.length > 0">
          <div class="m-card" [attr.data-service-call-id]="m.id"
               *ngFor="let m of filteredServiceCallMaintenances; trackBy: trackByMaintenanceId">
            <div class="m-date-col" (click)="openMaintenance(m)">
              <div class="m-date-badge service">
                <span class="day">{{m.scheduledDate | date:'dd'}}</span>
                <span class="month">{{m.scheduledDate | date:'MMM yy'}}</span>
              </div>
            </div>
            <div class="m-info-col" (click)="openMaintenance(m)">
              <h4>{{m.title}}</h4>
              <div class="m-meta-row">
                <span class="m-equipment"><mat-icon class="meta-icon">electrical_services</mat-icon> {{m.equipment?.name ?? '–'}}</span>
                <span *ngIf="m.assignedUsers?.length" class="m-tech"><mat-icon class="meta-icon">group</mat-icon> {{getTechnicianNames(m)}}</span>
                <span *ngIf="!m.assignedUsers?.length && (m.assignedUser || m.assignedEmployee)" class="m-tech"><mat-icon class="meta-icon">person</mat-icon> {{m.assignedUser?.userName ?? m.assignedEmployee?.fullName}}</span>
              </div>
              <div *ngIf="m.notes" class="m-description-line">
                <mat-icon class="meta-icon">notes</mat-icon>
                <span>{{m.notes}}</span>
              </div>
            </div>
            <div class="m-status-col">
              <span class="status-chip" [ngClass]="getStatusClass(m.status)">{{getStatusLabel(m.status)}}</span>
              <button class="delete-btn" (click)="deleteMaintenance(m, $event)" title="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 4: Material -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">inventory_2</mat-icon>
        Material/Regie
      </ng-template>

      <div class="tab-content">
        <div class="rate-section">
          <div class="section-heading-row">
            <div>
              <h3 class="section-subtitle">
                <mat-icon>euro</mat-icon> Regiestundensätze
              </h3>
              <p class="section-hint">Diese Sätze können beim Erstellen und Bearbeiten von Einsätzen ausgewählt werden.</p>
            </div>
          </div>

          <div class="rate-list" *ngIf="hourlyRates.length > 0">
            <div class="rate-row" *ngFor="let rate of hourlyRates; trackBy: trackByHourlyRateId">
              <div class="rate-main">
                <mat-icon>sell</mat-icon>
                <div>
                  <strong>{{rate.label}}</strong>
                  <span *ngIf="rate.isDefault" class="default-rate">Standard</span>
                </div>
              </div>
              <span class="rate-price">{{rate.hourlyRate | number:'1.2-2'}} €/h</span>
              <div class="rate-actions" *ngIf="canManageHourlyRates">
                <button mat-icon-button (click)="startEditHourlyRate(rate)" matTooltip="Stundensatz bearbeiten">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteHourlyRate(rate)" matTooltip="Stundensatz löschen">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="empty-rate-hint" *ngIf="hourlyRates.length === 0">
            <mat-icon>info</mat-icon>
            <span>Noch keine Stundensätze. Lege z.B. Monteur, Programmierer oder Projektleitung an.</span>
          </div>

          <!-- Nur zeigen, wer serverseitig auch speichern darf – sonst endete
               jeder Klick in einem 403. -->
          <div class="rate-form" *ngIf="canManageHourlyRates">
            <mat-form-field appearance="outline" class="rate-name-field">
              <mat-label>Bezeichnung</mat-label>
              <input matInput [(ngModel)]="newHourlyRate.label" placeholder="z.B. Monteur">
            </mat-form-field>
            <mat-form-field appearance="outline" class="rate-price-field">
              <mat-label>€/h</mat-label>
              <input matInput type="number" [(ngModel)]="newHourlyRate.hourlyRate" min="0" step="0.01">
            </mat-form-field>
            <mat-checkbox [(ngModel)]="newHourlyRate.isDefault" color="primary">Standard</mat-checkbox>
            <button mat-raised-button color="primary" (click)="saveHourlyRate()" [disabled]="!newHourlyRate.label?.trim()">
              <mat-icon>{{editingHourlyRateId ? 'save' : 'add'}}</mat-icon>
              {{editingHourlyRateId ? 'Speichern' : 'Hinzufügen'}}
            </button>
            <button mat-stroked-button *ngIf="editingHourlyRateId" (click)="cancelHourlyRateEdit()">
              Abbrechen
            </button>
          </div>
        </div>

        <!-- ── Stundensatz-Zuordnung (nur für den konfigurierten Takeda-Kunden) ── -->
        <div class="rate-assign-section" *ngIf="isTakedaCustomer">
          <div class="section-heading-row">
            <div>
              <h3 class="section-subtitle">
                <mat-icon>badge</mat-icon> Stundensatz-Zuordnung
              </h3>
              <p class="section-hint">
                Legt fest, welcher der Sätze oben für welche Person gilt. Gespeichert wird
                nur die Zuordnung – der Preis bleibt am Stundensatz.
              </p>
            </div>
          </div>

          <div class="lv-loading" *ngIf="hourlyRatePersonsLoading">
            <mat-spinner diameter="28"></mat-spinner>
            <span>Personen werden geladen …</span>
          </div>

          <ng-container *ngIf="!hourlyRatePersonsLoading">

            <div class="empty-rate-hint" *ngIf="hourlyRates.length === 0">
              <mat-icon>info</mat-icon>
              <span>Lege zuerst oben mindestens einen Stundensatz an.</span>
            </div>

            <div class="empty-rate-hint" *ngIf="hourlyRatePersons.length === 0">
              <mat-icon>info</mat-icon>
              <span>
                Für diesen Stammkunden sind weder Team-Mitglieder noch Arbeiter hinterlegt.
              </span>
            </div>

            <div class="rate-assign-list" *ngIf="hourlyRatePersons.length > 0">
              <div class="rate-assign-row"
                   *ngFor="let person of hourlyRatePersons; trackBy: trackByHourlyRatePerson">

                <div class="rate-assign-person">
                  <mat-icon class="rate-assign-icon">
                    {{ person.personType === 'Worker' ? 'construction' : 'person' }}
                  </mat-icon>
                  <div>
                    <strong>{{ person.personName }}</strong>
                    <span class="rate-assign-type">
                      {{ person.personType === 'Worker' ? 'Arbeiter (ohne Login)' : 'Team-Mitglied' }}
                    </span>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="rate-assign-field">
                  <mat-label>Stundensatz</mat-label>
                  <mat-select
                    [ngModel]="person.customerHourlyRateId ?? null"
                    (ngModelChange)="onHourlyRateAssignmentChange(person, $event)"
                    [disabled]="!canManageHourlyRateAssignments
                                || savingAssignmentKey === hourlyRatePersonKey(person)">
                    <mat-option [value]="null">Nicht zugeordnet</mat-option>
                    <mat-option *ngFor="let rate of hourlyRates; trackBy: trackByHourlyRateId"
                                [value]="rate.id">
                      {{ rate.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-spinner diameter="20"
                             *ngIf="savingAssignmentKey === hourlyRatePersonKey(person)">
                </mat-spinner>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="tab-actions">
          <button mat-raised-button color="primary" (click)="toggleMaterialForm()">
            <mat-icon>{{showMaterialForm ? 'close' : 'add'}}</mat-icon>
            {{showMaterialForm ? 'Abbrechen' : 'Material hinzufügen'}}
          </button>
        </div>

        <!-- Add Material Form -->
        <div class="material-form" *ngIf="showMaterialForm">
          <mat-form-field appearance="outline">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [(ngModel)]="newMaterial.name" required>
          </mat-form-field>
          <mat-form-field appearance="outline" class="small-field">
            <mat-label>Menge</mat-label>
            <input matInput type="number" [(ngModel)]="newMaterial.quantity">
          </mat-form-field>
          <mat-form-field appearance="outline" class="small-field">
            <mat-label>Einheit</mat-label>
            <input matInput [(ngModel)]="newMaterial.unit">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Beschreibung</mat-label>
            <input matInput [(ngModel)]="newMaterial.description">
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="saveMaterial()" [disabled]="!newMaterial.name?.trim() || addingMaterial">
            Speichern
          </button>
        </div>

        <div *ngIf="materials.length === 0 && !showMaterialForm" class="empty-tab">
          <mat-icon>inventory_2</mat-icon>
          <p>Keine Materialien hinterlegt.</p>
        </div>

        <div class="material-list" *ngIf="materials.length > 0">
          <div class="material-item" *ngFor="let mat of materials; trackBy: trackByCustomerMaterialId">
            <div class="mat-info">
              <mat-icon class="mat-item-icon">inventory_2</mat-icon>
              <div>
                <strong>{{mat.name}}</strong>
                <span class="mat-desc" *ngIf="mat.description"> – {{mat.description}}</span>
              </div>
            </div>
            <div class="mat-qty">{{mat.quantity}} {{mat.unit}}</div>
            <button mat-icon-button color="warn" (click)="deleteMaterial(mat)" matTooltip="Entfernen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>

        <!-- Wartungs-Material (aufklappbar) -->
        <div class="wartung-material-section" *ngIf="maintenancesWithMaterials.length > 0">
          <h3 class="section-subtitle">
            <mat-icon>build</mat-icon> Material aus Wartungen & Einsätzen
          </h3>
          <mat-accordion>
            <mat-expansion-panel *ngFor="let m of maintenancesWithMaterials; trackBy: trackByMaintenanceId" class="wartung-mat-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="panel-type-icon">{{m.recurrenceType !== 'None' ? 'event_repeat' : 'build'}}</mat-icon>
                  {{m.title}}
                </mat-panel-title>
                <mat-panel-description>
                  {{m.materials.length}} Material{{m.materials.length !== 1 ? 'ien' : ''}}
                  <span class="panel-date">{{m.scheduledDate | date:'dd.MM.yyyy'}}</span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="wartung-mat-list">
                <div class="wartung-mat-row" *ngFor="let mat of m.materials; trackBy: trackByMaintenanceMaterialId">
                  <div class="wartung-mat-info">
                    <mat-icon class="mat-item-icon small">inventory_2</mat-icon>
                    <span>{{mat.name}}</span>
                  </div>
                  <span class="wartung-mat-qty">{{mat.quantity}} {{mat.unit}}</span>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <!-- ── Takeda Leistungsverzeichnis (nur für den konfigurierten Takeda-Kunden) ── -->
        <div class="lv-section" *ngIf="isTakedaCustomer">
          <div class="section-heading-row">
            <div>
              <h3 class="section-subtitle">
                <mat-icon>request_quote</mat-icon> Takeda Leistungsverzeichnis
              </h3>
              <p class="section-hint">
                Eigenständige Preisgrundlage für Takeda-Regie – unabhängig von den
                Materialien und Stundensätzen oberhalb.
              </p>
            </div>
          </div>

          <div class="lv-card">

            <div class="lv-loading" *ngIf="takedaLvLoading">
              <mat-spinner diameter="28"></mat-spinner>
              <span>Leistungsverzeichnis wird geladen …</span>
            </div>

            <ng-container *ngIf="!takedaLvLoading">

              <!-- Noch kein LV vorhanden -->
              <div class="lv-empty" *ngIf="!activeTakedaLv">
                <div class="lv-empty-icon">
                  <mat-icon>request_quote</mat-icon>
                </div>
                <div>
                  <strong>Noch kein Leistungsverzeichnis importiert</strong>
                  <p class="section-hint">
                    Importiere das aktuelle Takeda-Regie-LV. Das importierte LV wird automatisch als aktiv markiert.
                  </p>
                </div>
              </div>

              <!-- Aktives LV -->
              <div class="lv-active" *ngIf="activeTakedaLv as lv">
                <div class="lv-file-icon">
                  <mat-icon>description</mat-icon>
                </div>

                <div class="lv-active-main">
                  <div class="lv-title-row">
                    <strong>{{lv.name}}</strong>
                    <span class="lv-active-chip">Aktiv</span>
                  </div>

                  <div class="lv-meta">
                    <span>
                      <mat-icon>insert_drive_file</mat-icon>
                      {{lv.fileName}}
                    </span>
                    <span>
                      <mat-icon>list</mat-icon>
                      {{lv.positionCount}} Positionen
                    </span>
                    <span>
                      <mat-icon>schedule</mat-icon>
                      Importiert am {{lv.importedAtUtc | date:'dd.MM.yyyy HH:mm'}}
                    </span>
                  </div>
                </div>

                <button mat-stroked-button type="button" (click)="toggleTakedaLvPositionen()">
                  <mat-icon>{{takedaLvPositionsVisible ? 'visibility_off' : 'visibility'}}</mat-icon>
                  {{takedaLvPositionsVisible ? 'Positionen ausblenden' : 'Positionen anzeigen'}}
                </button>
              </div>

              <!-- Import / neues LV -->
              <div class="lv-upload" *ngIf="canManageTakedaLv">
                <div class="lv-upload-text">
                  <strong>{{activeTakedaLv ? 'Neues Leistungsverzeichnis importieren' : 'Leistungsverzeichnis importieren'}}</strong>
                  <span class="section-hint" *ngIf="activeTakedaLv">
                    Das bisherige LV bleibt erhalten und wird automatisch inaktiv.
                  </span>
                </div>

                <input
                  #lvFileInput
                  type="file"
                  hidden
                  accept=".xlsx,.xlsm,.xls"
                  (change)="onTakedaLvFileSelected($event)">

                <button mat-stroked-button type="button" (click)="lvFileInput.click()" [disabled]="takedaLvImporting">
                  <mat-icon>attach_file</mat-icon>
                  Datei wählen
                </button>

                <span class="lv-selected-file" *ngIf="selectedTakedaLvFile">
                  {{selectedTakedaLvFile.name}}
                </span>

                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  [disabled]="!selectedTakedaLvFile || takedaLvImporting"
                  (click)="importTakedaLv(lvFileInput)">
                  <mat-spinner *ngIf="takedaLvImporting" diameter="18"></mat-spinner>
                  <mat-icon *ngIf="!takedaLvImporting">cloud_upload</mat-icon>
                  {{takedaLvImporting ? 'Import läuft …' : 'Leistungsverzeichnis importieren'}}
                </button>
              </div>

              <!-- Historie -->
              <div class="lv-history" *ngIf="inactiveTakedaLvs.length > 0">
                <span class="lv-history-label">Frühere Versionen:</span>
                <span class="lv-history-item" *ngFor="let oldLv of inactiveTakedaLvs">
                  {{oldLv.name}} · {{oldLv.importedAtUtc | date:'dd.MM.yyyy'}}
                </span>
              </div>

              <!-- Positionen -->
              <div class="lv-positionen" *ngIf="takedaLvPositionsVisible && activeTakedaLv">
                <div class="lv-position-toolbar">
                  <div class="lv-search">
                    <mat-icon>search</mat-icon>
                    <input
                      type="text"
                      [(ngModel)]="takedaLvSearch"
                      placeholder="Nummer, Stichwort oder Bezeichnung suchen …"
                      (keyup.enter)="searchTakedaLvPositionen()">
                    <button
                      mat-icon-button
                      type="button"
                      *ngIf="takedaLvSearch"
                      (click)="clearTakedaLvSearch()"
                      matTooltip="Suche zurücksetzen">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>

                  <button mat-stroked-button type="button" (click)="searchTakedaLvPositionen()">
                    Suchen
                  </button>

                  <button
                    mat-raised-button
                    color="primary"
                    type="button"
                    *ngIf="canManageTakedaLv"
                    (click)="startAddTakedaLvPosition()"
                    [disabled]="takedaLvAdding || takedaLvSaving">
                    <mat-icon>add</mat-icon>
                    Zeile hinzufügen
                  </button>

                  <span class="lv-spacer"></span>

                  <span class="lv-result-count" *ngIf="!takedaLvPositionsLoading">
                    {{takedaLvPositionen.length}} Treffer
                    <ng-container *ngIf="takedaLvPositionen.length > 0">
                      · {{takedaLvPageStart}}–{{takedaLvPageEnd}} angezeigt
                    </ng-container>
                  </span>
                </div>

                <div class="lv-loading" *ngIf="takedaLvPositionsLoading">
                  <mat-spinner diameter="28"></mat-spinner>
                  <span>Positionen werden geladen …</span>
                </div>

                <div class="lv-table-wrap" *ngIf="!takedaLvPositionsLoading && (takedaLvPositionen.length > 0 || takedaLvAdding)">
                  <table class="lv-table lv-editable-table">
                    <thead>
                      <tr>
                        <th>Nummer</th>
                        <th>Stichwort</th>
                        <th>Bezeichnung</th>
                        <th>Typ</th>
                        <th class="numeric">LV-Menge</th>
                        <th>Einheit</th>
                        <th class="numeric">Lohn</th>
                        <th class="numeric">Sonstiges</th>
                        <th class="numeric">Einheitspreis</th>
                        <th class="numeric">Gesamtbetrag</th>
                        <th>Markierung</th>
                        <th>LV-Notiz</th>
                        <th class="lv-actions" *ngIf="canManageTakedaLv">Aktionen</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Neue Zeile -->
                      <tr class="lv-edit-row lv-new-row" *ngIf="takedaLvAdding">
                        <td><input [(ngModel)]="takedaLvNewPosition.nummer" placeholder="Nummer"></td>
                        <td><input [(ngModel)]="takedaLvNewPosition.stichwort" placeholder="Stichwort"></td>
                        <td><input [(ngModel)]="takedaLvNewPosition.bezeichnung" placeholder="z.B. LED-Leuchte Reinraum"></td>
                        <td>
                          <select [(ngModel)]="takedaLvNewPosition.typ">
                            <option value="P">Position</option>
                            <option value="LG">Leistungsgruppe</option>
                            <option value="UG">Untergruppe</option>
                            <option value="GT">Gruppentext</option>
                          </select>
                        </td>
                        <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="takedaLvNewPosition.lvMenge"></td>
                        <td><input [(ngModel)]="takedaLvNewPosition.einheit" placeholder="Einheit"></td>
                        <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="takedaLvNewPosition.lohn"></td>
                        <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="takedaLvNewPosition.sonstiges"></td>
                        <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="takedaLvNewPosition.einheitspreis"></td>
                        <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="takedaLvNewPosition.gesamtbetrag"></td>
                        <td><input [(ngModel)]="takedaLvNewPosition.markierungskennzeichen" placeholder="Markierung"></td>
                        <td><input [(ngModel)]="takedaLvNewPosition.lvNotiz" placeholder="LV-Notiz"></td>
                        <td class="lv-actions">
                          <button mat-icon-button color="primary" type="button" (click)="saveNewTakedaLvPosition()" [disabled]="takedaLvSaving" matTooltip="Speichern">
                            <mat-icon>check</mat-icon>
                          </button>
                          <button mat-icon-button type="button" (click)="cancelAddTakedaLvPosition()" [disabled]="takedaLvSaving" matTooltip="Abbrechen">
                            <mat-icon>close</mat-icon>
                          </button>
                        </td>
                      </tr>

                      <ng-container *ngFor="let p of visibleTakedaLvPositionen; trackBy: trackByTakedaLvPositionId">
                        <!-- Anzeige -->
                        <tr *ngIf="editingTakedaLvPositionId !== p.id">
                          <td class="lv-number">{{p.nummer || '–'}}</td>
                          <td>{{p.stichwort || '–'}}</td>
                          <td class="lv-bezeichnung">{{p.bezeichnung || '–'}}</td>
                          <td>
                            <span class="lv-type-chip" [attr.data-type]="p.typ">
                              {{takedaLvTypLabel(p.typ)}}
                            </span>
                          </td>
                          <td class="numeric">{{p.lvMenge != null ? (p.lvMenge | number:'1.0-4') : '–'}}</td>
                          <td>{{p.einheit || '–'}}</td>
                          <td class="numeric">{{p.lohn != null ? (p.lohn | number:'1.2-4') : '–'}}</td>
                          <td class="numeric">{{p.sonstiges != null ? (p.sonstiges | number:'1.2-4') : '–'}}</td>
                          <td class="numeric">{{p.einheitspreis != null ? (p.einheitspreis | number:'1.2-4') : '–'}}</td>
                          <td class="numeric">{{p.gesamtbetrag != null ? (p.gesamtbetrag | number:'1.2-4') : '–'}}</td>
                          <td>{{p.markierungskennzeichen || '–'}}</td>
                          <td>{{p.lvNotiz || '–'}}</td>
                          <td class="lv-actions" *ngIf="canManageTakedaLv">
                            <button mat-icon-button type="button" (click)="startEditTakedaLvPosition(p)" matTooltip="Bearbeiten">
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" type="button" (click)="deleteTakedaLvPosition(p)" matTooltip="Löschen">
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <!-- Bearbeiten -->
                        <tr class="lv-edit-row" *ngIf="editingTakedaLvPositionId === p.id && takedaLvEditPosition as edit">
                          <td><input [(ngModel)]="edit.nummer"></td>
                          <td><input [(ngModel)]="edit.stichwort"></td>
                          <td><input [(ngModel)]="edit.bezeichnung" placeholder="z.B. LED-Leuchte Reinraum"></td>
                          <td>
                            <select [(ngModel)]="edit.typ">
                              <option value="P">Position</option>
                              <option value="LG">Leistungsgruppe</option>
                              <option value="UG">Untergruppe</option>
                              <option value="GT">Gruppentext</option>
                            </select>
                          </td>
                          <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="edit.lvMenge"></td>
                          <td><input [(ngModel)]="edit.einheit"></td>
                          <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="edit.lohn"></td>
                          <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="edit.sonstiges"></td>
                          <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="edit.einheitspreis"></td>
                          <td><input class="numeric-input" type="number" step="0.0001" [(ngModel)]="edit.gesamtbetrag"></td>
                          <td><input [(ngModel)]="edit.markierungskennzeichen"></td>
                          <td><input [(ngModel)]="edit.lvNotiz"></td>
                          <td class="lv-actions">
                            <button mat-icon-button color="primary" type="button" (click)="saveEditTakedaLvPosition(p)" [disabled]="takedaLvSaving" matTooltip="Speichern">
                              <mat-icon>check</mat-icon>
                            </button>
                            <button mat-icon-button type="button" (click)="cancelEditTakedaLvPosition()" [disabled]="takedaLvSaving" matTooltip="Abbrechen">
                              <mat-icon>close</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>

                <div class="lv-pagination" *ngIf="!takedaLvPositionsLoading && takedaLvPositionen.length > 0">
                  <button
                    mat-stroked-button
                    type="button"
                    (click)="previousTakedaLvPage()"
                    [disabled]="takedaLvCurrentPage <= 1">
                    <mat-icon>chevron_left</mat-icon>
                    Zurück
                  </button>

                  <span class="lv-page-info">
                    Seite {{takedaLvCurrentPage}} von {{takedaLvTotalPages}}
                    <span class="lv-page-size">· {{takedaLvPageSize}} Einträge pro Seite</span>
                  </span>

                  <button
                    mat-stroked-button
                    type="button"
                    (click)="nextTakedaLvPage()"
                    [disabled]="takedaLvCurrentPage >= takedaLvTotalPages">
                    Weiter
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                </div>

                <div class="lv-no-results" *ngIf="!takedaLvPositionsLoading && takedaLvPositionen.length === 0 && !takedaLvAdding">
                  <mat-icon>search_off</mat-icon>
                  <span>Keine passenden LV-Positionen gefunden.</span>
                </div>
              </div>

            </ng-container>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Loading -->
<div *ngIf="loading" class="loading-page">
  <mat-spinner diameter="48"></mat-spinner>
</div>
